import { SanityKeyed, ImageAndIngredients as ImageAndIngredientsProps } from 'types/studio/studio';
import styles from './ImageAndIngredients.module.scss';
import ImageAndIngredientsMobile from './ImageAndIngredientsMobile/ImageAndIngredientsMobile';
import ImageAndIngredientsDesktop from './ImageAndIngredientsDesktop/ImageAndIngredientsDesktop';
import { CommonSectionProps } from '../types';

const ImageAndIngredients = (props: SanityKeyed<ImageAndIngredientsProps> & CommonSectionProps) => {
  const {
    _key: key,
    _type: sectionType,
    variation,
    headline,
    text,
    textBold,
    imageAndIngredientsImage,
    ingredientsTitle,
    ingredientsItems,
    showCheckmark,
    padding,
    visibleOnPageLoad
  } = props;
  return (
    <>
      <div className={styles.mobileOnly}>
        <ImageAndIngredientsMobile
          _type={sectionType}
          imageAndIngredientsImage={imageAndIngredientsImage}
          variation={variation}
          headline={headline}
          ingredientsTitle={ingredientsTitle}
          text={text}
          textBold={textBold}
          ingredientsItems={ingredientsItems}
          showCheckmark={showCheckmark}
          padding={padding}
          visibleOnPageLoad={visibleOnPageLoad}
          _key={key}
        />
      </div>
      <div className={styles.desktopOnly}>
        <ImageAndIngredientsDesktop
          _type={sectionType}
          imageAndIngredientsImage={imageAndIngredientsImage}
          variation={variation}
          headline={headline}
          ingredientsTitle={ingredientsTitle}
          text={text}
          textBold={textBold}
          ingredientsItems={ingredientsItems}
          showCheckmark={showCheckmark}
          padding={padding}
          visibleOnPageLoad={visibleOnPageLoad}
          _key={key}
        />
      </div>
    </>
  );
};

export default ImageAndIngredients;
